import * as React from "react";
const SvgArrowOutward = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, viewBox: "0 0 20 20", fill: "currentColor", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M7.063 14 6 12.938 14.438 4.5H7V3h10v10h-1.5V5.563z" }));
export default SvgArrowOutward;
